import { render } from "./About.vue?vue&type=template&id=41eeb5dc&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=41eeb5dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41eeb5dc"]])

export default __exports__